const LAST_TURN_PREFIX = 'jg:lastTurnId:';

function safeSessionId(value = null) {
  const normalized = String(value || '').trim();
  return normalized || null;
}

export function getLastTurnStorageKey(missionSessionId) {
  const sessionId = safeSessionId(missionSessionId);
  return sessionId ? `${LAST_TURN_PREFIX}${sessionId}` : null;
}

export function readLastTurnIdForSession(missionSessionId) {
  const storageKey = getLastTurnStorageKey(missionSessionId);
  if (!storageKey) return null;
  try {
    const value = localStorage.getItem(storageKey);
    const normalized = String(value || '').trim();
    return normalized || null;
  } catch (error) {
    return null;
  }
}

export function writeLastTurnIdForSession(missionSessionId, lastTurnId) {
  const storageKey = getLastTurnStorageKey(missionSessionId);
  const normalizedTurnId = String(lastTurnId || '').trim();
  if (!storageKey || !normalizedTurnId) return false;
  try {
    localStorage.setItem(storageKey, normalizedTurnId);
    return true;
  } catch (error) {
    return false;
  }
}

export function clearLastTurnIdForSession(missionSessionId) {
  const storageKey = getLastTurnStorageKey(missionSessionId);
  if (!storageKey) return false;
  try {
    localStorage.removeItem(storageKey);
    return true;
  } catch (error) {
    return false;
  }
}
